declare const google: any;

export class MapPopup extends google.maps.OverlayView {
  position: any;
  containerDiv: HTMLDivElement;

  constructor(position, content, type) {
    super();
    this.position = position;

    content.classList.add('popup-bubble');

    // Creates bubble that will wrap the content
    const bubbleAnchor = document.createElement('div');
    bubbleAnchor.classList.add('popup-bubble-anchor');
    bubbleAnchor.append(content);

    // Creates overlay container and appends the content passed to it
    this.containerDiv = document.createElement('div');
    this.containerDiv.classList.add('popup-container');
    this.containerDiv.classList.add(type === 'detailed' ? 'detailed' : 'chip');
    this.containerDiv.appendChild(bubbleAnchor);

    // Stop clicks, etc., from bubbling up to the map.
    google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
  }

  onAdd() {
    this.getPanes().floatPane.appendChild(this.containerDiv);
  }

  onRemove() {
    if (this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv);
    }
  }

  draw = () => {
    const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

    // Hide the popup when it is far out of view.
    const display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
        'block' :
        'none';

    if (display === 'block') {
      this.containerDiv.style.left = divPosition.x + 'px';
      this.containerDiv.style.top = divPosition.y + 'px';
    }
    if (this.containerDiv.style.display !== display) {
      this.containerDiv.style.display = display;
    }
  }

  updatePopup = (details: any) => {
    if (details.position) {
      this.position = details.position;
    }

    if (details.content) {
      const bubbleAnchor = this.containerDiv.getElementsByClassName('popup-bubble-anchor')[0];
      details.content.classList.add('popup-bubble');
      bubbleAnchor.innerHTML = '';
      bubbleAnchor.append(details.content);
    }
  }
}
